import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import ProductcompositionEditFormImpl from './ProductcompositionEditFormImpl';
import ProductcompositionList from './ProductcompositionList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import ProductcompositionListView from './ProductcompositionListView'


export default function ProductcompositionDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.productcompositionDashboard);
  const [ productcompositionId, setProductcompositionId] = React.useState('');
  const [reloadProductcompositionList, setReloadProductcompositionList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <ProductcompositionEditFormImpl 
            setReloadProductcompositionList={setReloadProductcompositionList}
            productcompositionId={productcompositionId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <ProductcompositionListView 
                      setProductcompositionId = {setProductcompositionId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
